module.exports = __webpack_public_path__ + "static/media/click-09.192ce7f6.mp3";